/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './CustomAssistantsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#getCustomAssistant
 */
export const GET_CUSTOM_ASSISTANT_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_getCustomAssistant';
export const GET_CUSTOM_ASSISTANT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CUSTOM_ASSISTANT_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#listCustomAssistants
 */
export const LIST_CUSTOM_ASSISTANTS_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_listCustomAssistants';
export const LIST_CUSTOM_ASSISTANTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_CUSTOM_ASSISTANTS_QUERY_FIELD_NAME,
  args: ['pageLength', 'searchTerm', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listCustomAssistantsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#createCustomAssistant
 */
export const CREATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_createCustomAssistant';
export const CREATE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['name', 'welcomeMessage', 'instructions', 'setUpInstructions', 'icon', 'description', 'status', 'enabledContext', 'resources', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#duplicateCustomAssistant
 */
export const DUPLICATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_duplicateCustomAssistant';
export const DUPLICATE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DUPLICATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.duplicateCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#updateCustomAssistant
 */
export const UPDATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_updateCustomAssistant';
export const UPDATE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id', 'name', 'welcomeMessage', 'instructions', 'setUpInstructions', 'icon', 'description', 'status', 'enabledContext', 'resources', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#deleteCustomAssistant
 */
export const DELETE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_deleteCustomAssistant';
export const DELETE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.deleteCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#installCustomAssistantTemplateFromGlobalId
 */
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_installCustomAssistantTemplateFromGlobalId';
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION_FIELD_NAME,
  args: ['templateGlobalId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.installCustomAssistantTemplateFromGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#lookupUserInstalledAssistantByGlobalId
 */
export const LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_lookupUserInstalledAssistantByGlobalId';
export const LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['globalId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.lookupUserInstalledAssistantByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#listCustomAssistantTemplates
 */
export const LIST_CUSTOM_ASSISTANT_TEMPLATES_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_listCustomAssistantTemplates';
export const LIST_CUSTOM_ASSISTANT_TEMPLATES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_CUSTOM_ASSISTANT_TEMPLATES_QUERY_FIELD_NAME,
  args: ['pageLength', 'visibility', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.listCustomAssistantTemplatesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#installCustomAssistantTemplate
 */
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_installCustomAssistantTemplate';
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: INSTALL_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.installCustomAssistantTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#uninstallCustomAssistantTemplate
 */
export const UNINSTALL_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_uninstallCustomAssistantTemplate';
export const UNINSTALL_CUSTOM_ASSISTANT_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNINSTALL_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.uninstallCustomAssistantTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#installCustomAssistantTemplateOnPortal
 */
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_ON_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_installCustomAssistantTemplateOnPortal';
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_ON_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: INSTALL_CUSTOM_ASSISTANT_TEMPLATE_ON_PORTAL_MUTATION_FIELD_NAME,
  args: ['templateId', 'destinationPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.installCustomAssistantTemplateOnPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#uninstallCustomAssistantTemplateFromPortal
 */
export const UNINSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_uninstallCustomAssistantTemplateFromPortal';
export const UNINSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNINSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_PORTAL_MUTATION_FIELD_NAME,
  args: ['templateId', 'destinationPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.uninstallCustomAssistantTemplateFromPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#isCustomAssistantTemplateInstalled
 */
export const IS_CUSTOM_ASSISTANT_TEMPLATE_INSTALLED_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_isCustomAssistantTemplateInstalled';
export const IS_CUSTOM_ASSISTANT_TEMPLATE_INSTALLED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: IS_CUSTOM_ASSISTANT_TEMPLATE_INSTALLED_QUERY_FIELD_NAME,
  args: ['templateId', 'destinationPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.isCustomAssistantTemplateInstalledRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#listCustomAssistantsTemplateInstalls
 */
export const LIST_CUSTOM_ASSISTANTS_TEMPLATE_INSTALLS_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_listCustomAssistantsTemplateInstalls';
export const LIST_CUSTOM_ASSISTANTS_TEMPLATE_INSTALLS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_CUSTOM_ASSISTANTS_TEMPLATE_INSTALLS_QUERY_FIELD_NAME,
  args: ['customAssistantTemplateId', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.listCustomAssistantsTemplateInstallsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#createCustomAssistantTemplate
 */
export const CREATE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_createCustomAssistantTemplate';
export const CREATE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['name', 'welcomeMessage', 'instructions', 'setUpInstructions', 'icon', 'description', 'type', 'status', 'enabledContext', 'resources', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.createCustomAssistantTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#updateCustomAssistantTemplate
 */
export const UPDATE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_updateCustomAssistantTemplate';
export const UPDATE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['id', 'name', 'welcomeMessage', 'instructions', 'setUpInstructions', 'icon', 'description', 'type', 'status', 'enabledContext', 'resources', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.updateCustomAssistantTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CustomAssistantsService#deleteCustomAssistantTemplate
 */
export const DELETE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CustomAssistantsService_deleteCustomAssistantTemplate';
export const DELETE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_CUSTOM_ASSISTANT_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.deleteCustomAssistantTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});